import React from 'react';
import classNames from "classnames";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import {useSelector} from 'react-redux'
import {makeStyles} from "@material-ui/styles";
import RenderComponents from "../JsonScreen/Screen/ScreenComponents/RenderComponents";
import {JsonScreenProvider} from '../../ContextComponents/JsonScreenContext'
import {uid} from "react-uid";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {generateBorder} from "../JsonScreen/Utils/generateStyles";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
    head: {
        position: 'relative',
        [theme.breakpoints.up("sm")]: {
            flexGrow: 1,
            //   marginLeft: 0,
            transition: theme.transitions.create(["margin", "width"], {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen
            })
        }
    },
    headShift: {
        flexGrow: 1,
        // marginLeft: 0,
        transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        [theme.breakpoints.up("sm")]: {
            //marginLeft: 280,
            transition: theme.transitions.create(["margin", "width"], {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen
            })
        }
    },
    header: {
        flexGrow: 1,
    },
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        '&:focus': {
            backgroundColor: 'rgba(216, 216, 216, 0.2)'
        }
    },
    appBarRoot: props => {
        const borderObj = generateBorder(props);
        return {
            ...borderObj,
            boxShadow: props.boxShadow,
            borderColor: props.borderColor,
            borderBottomColor: props.borderColor,
            borderRightColor: props.borderColor,
            borderRadius: props.borderRadius,
            //backgroundColor: props.background ? props.background : theme.palette.primary.main
        }
    }
}))

const Header = (props) => {
    const {
        component: {
            children = [],
            styles: sourceStyles
        },
        doActions, onChangeFields, screenName, headerRef
    } = props;
    const {isOpenDrawer, drawerWidth} = useSelector(state => state.app);
    const isMobile = useMediaQuery('(max-width:700px)');
    const styles = sourceStyles ? sourceStyles[0] : {};
    const classes = useStyles(styles);
    return (
        <JsonScreenProvider value={{
            doActions: (action, context, event) => doActions(action, context, event, screenName),
            setValue: (value, path, trackChange) => onChangeFields(value, `param.${screenName}.${path}`, trackChange),
            screenName
        }}>
            <div className={classNames(classes.head, {[classes.headShift]: isOpenDrawer})}
                 style={{marginLeft: isOpenDrawer ? isMobile ? 0 : drawerWidth : 0}}
                 id={'headerElement'}
                 ref={headerRef}
            >
                <AppBar position={styles.position || "static"}
                        classes={{root: classes.appBarRoot}}
                        className={clsx(styles.className)}
                >
                    <Toolbar variant="dense" style={{...styles}}>
                        {children.map(component => {
                            return <RenderComponents
                                key={uid(component)}
                                element={component}
                                isTableCell={false}
                                actionsContext={{}}
                            />
                        })}
                    </Toolbar>
                </AppBar>
            </div>
        </JsonScreenProvider>
    )
}

export default Header;